export const routePath = {
  userInformations: '/user/informations',
};

export default {
  routePath,
};
